<template>
  <div class="v2-head">
    <div class="v2-wrap clearfix">
      <ul class="head-list clearfix">
        <li class="hd-item clearfix" v-show="userInfo.username">
          <el-popover
            v-model="visible"
            placement="bottom"
            width="120"
            trigger="click"
          >
            <div class="popover-cont">
              <div class="line" @click="toCenter">个人中心</div>
              <div class="line" @click="loginOut">退出登录</div>
            </div>
            <span class="tit" slot="reference" >{{userInfo.username}}</span>
          </el-popover>
        </li>
        <li class="hd-item clearfix" v-show="!userInfo.username" >
          <span class="tit" @click="$router.push('/v2/login')">登录</span>
        </li>
        <li class="hd-item clearfix" v-show="!userInfo.username" >
          <span class="tit" @click="$router.push('/v2/login')">注册</span>
        </li>
        <li class="hd-item clearfix">
          <span class="tit" @click="$router.push('/cent/order')" v-show="userInfo.username" >我的订单</span>
        </li>
<!--        <li class="hd-item clearfix">
          <span class="ico cart"></span>
          <span class="tit">购物车</span>
        </li>
        <li class="hd-item clearfix">
          <span class="ico qr"></span>
          <span class="tit">手机版</span>
        </li>-->
      </ul>
    </div>
  </div>
</template>

<script>
import storage from '@/plugins/storage';

export default {
  data () {
    return {
      userInfo: {},
      visible: false
    }
  },
  mounted () {
    if (storage.getItem('userInfo')) {
      this.userInfo = JSON.parse(storage.getItem('userInfo'));
      // console.log('----------------', this.userInfo)
    }
  },
  methods: {
    toCenter () {
      this.$router.push('/cent/person')
      this.visible = false
    },
    /* 退出登录 */
    loginOut () {
      storage.removeItem('accessToken');
      storage.removeItem('refreshToken');
      storage.removeItem('userInfo');
      this.userInfo = '';
      this.$router.push('/');
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .v2-head {
    position: fixed;
    z-index: $z-index-v2 + 1;
    top: 0;
    width: 100%;
    height: $head-height-v2;
    background: #0E1928;

    .head-list {
      float: right;
      padding-top: ($head-height-v2 - 18px) / 2;

      .hd-item {
        float: left;
        height: 18px;
        padding: 0 20px;
        line-height: 18px;
        color: #E8E8E8;
        font-size: 12px;
        border-right: 1px solid #666;
        border-left: 1px solid #666;

        .ico {
          float: left;
          width: 18px;
          height: 18px;
          margin-right: 6px;

          &.cart {
            background-image: url('~@/assets/images/v2/cart.png');
          }

          &.qr {
            background-image: url('~@/assets/images/v2/qr.png');
          }
        }

        .tit {
          float: left;
          cursor: pointer;
        }

        &:first-child {
          border-left: none;
        }

        &:last-child {
          padding-right: 0;
          border-right: none;
        }
      }
    }
  }

  .popover-cont {
    .line {
      margin-top: 10px;
      line-height: 24px;
      text-align: center;
      cursor: pointer;

      &:first-child {
        margin-top: 0;
      }

      &:hover {
        color: $light-color-v2;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/saas/v2/Head.vue